import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

export const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const currentYear = new Date().getFullYear();
  
  const phones = ["+964 750 208 9427", "+964 750 033 4545"];
  const location = "Iraq / Zakho";

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1e1919] text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <div className="bg-black px-3 py-2 rounded">
                <img 
                  src="https://customer-assets.emergentagent.com/job_e89f86fd-ccbb-428c-8bc5-5519914e6241/artifacts/77hlnuis_image.png"
                  alt={language === 'ar' ? 'شعار شركة الحنادس' : 'AL HANADIS COMPANY Logo'}
                  className="h-10 w-auto object-contain"
                />
              </div>
            </div>
            <p className="text-[#bbb5ae] leading-relaxed">
              {t.tagline}
            </p>
            <p className="text-[#bbb5ae] mt-4">
              {t.established} 2023
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">{t.quickLinks}</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-[#bbb5ae] hover:text-white transition-colors"
                >
                  {t.home}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-[#bbb5ae] hover:text-white transition-colors"
                >
                  {t.about}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-[#bbb5ae] hover:text-white transition-colors"
                >
                  {t.products}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-[#bbb5ae] hover:text-white transition-colors"
                >
                  {t.contact}
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">{t.contactInformation}</h4>
            <ul className="space-y-2 text-[#bbb5ae]">
              {phones.map((phone, index) => (
                <li key={index} dir="ltr">
                  <a href={`tel:${phone}`} className="hover:text-white transition-colors">
                    {phone}
                  </a>
                </li>
              ))}
              <li className="mt-4">{location}</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#736c64] mt-12 pt-8 text-center">
          <p className="text-[#bbb5ae]">
            &copy; {currentYear} {t.companyName}. {t.allRightsReserved}.
          </p>
        </div>
      </div>
    </footer>
  );
};
